module.exports = __webpack_public_path__ + "static/addbookmark-37e769f0188d8b62899ce4da301f857c.png";